import * as OAuth2ScopeOperations from './operations';

export {
    OAuth2ScopeOperations
};